export const MAX_SPLITTER_VALUE_KEY = 'MAX_SPLITTER_VALUE_KEY';
export const SPLITTER_VALUE_KEY = 'SPLITTER_VALUE_KEY';
export const FILTER_SPLITTER_VALUE_KEY = 'FILTER_SPLITTER_VALUE_KEY';
export const IDO_INSTANCE_VISIBLE_FIELD_LIST_KEY = 'IDO_INSTANCE_VISIBLE_FIELD_LIST_KEY_V3';
export const IDO_INSTANCE_COLUMN_CONFIG_KEY = 'IDO_INSTANCE_COLUMN_CONFIG_KEY_V1';
export const GROUPED_IOD_LIST_SPLITTER = 'GROUPED_IOD_LIST_SPLITTER';
